import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'environments/environment';
import { EndpointsConstants } from 'app/shared/constants/endpoints.constants';


/** Wrapper service for angular HttpClient */

export interface IRequestOptions {
  headers?: HttpHeaders;
  observe?: 'body';
  params?: HttpParams;
  reportProgress?: boolean;
  responseType?: 'json';
  withCredentials?: boolean;
  body?: any;
}

export function applicationHttpClientCreator(http: HttpClient) {
  return new HttpClientService(http);
}

@Injectable({
  providedIn: 'root'
})
export class HttpClientService {

  // Extending the HttpClient through the Angular DI.
  public constructor(public http: HttpClient) {
    // If you don't want to use the extended versions in some cases you can access the public property and use the original one.
    // for ex. this.httpClient.http.get(...)
  }

  /**
   * GET request
   *
   * @param endPoint end point of the api
   *
   * @param options options of the request like headers, body, etc.
   */
  get<T>(endPoint: string, queryParameters?: {}): Observable<T> {
    /**
     * IMPORTANT
     * Attach return 200 status on empty results parameter to all GET calls
     * API sometimes returns 404 for empty results and this parameter will make sure that we will get status 200 and empty array as a result
     */
    const endpointUrl = `${environment.apiUrl}${endPoint}`;

    return this.http.get<T>(endpointUrl, { params: this.getParams(queryParameters) });
  }

  /**
   * POST request
   *
   * @param endPoint end point of the api
   *
   * @param body body of the request.
   *
   * @param options options of the request like headers, body, etc.
   */
  post<T>(endPoint: string, body: object, options?: IRequestOptions): Observable<T> {
    return this.http.post<T>(`${environment.apiUrl}${endPoint}`, body, options);
  }

  /**
   * PUT request
   *
   * @param endPoint end point of the api
   *
   * @param body body of the request.
   *
   * @param options options of the request like headers, body, etc.
   */
  put<T>(endPoint: string, body?: object, options?: IRequestOptions): Observable<T> {
    return this.http.put<T>(`${environment.apiUrl}${endPoint}`, body, options);
  }

  /**
   * PATCH request
   *
   * @param endPoint end point of the api
   *
   * @param body body of the request.
   *
   * @param options options of the request like headers, body, etc.
   */
  patch<T>(endPoint: string, body: object, options?: IRequestOptions): Observable<T> {
    return this.http.patch<T>(`${environment.apiUrl}${endPoint}`, body, options);
  }

  /**
   * DELETE request
   *
   * @param endPoint end point of the api
   *
   * @param options options of the request like headers, body, etc.
   */
  delete<T>(endPoint: string, options?: IRequestOptions): Observable<T> {
    return this.http.delete<T>(`${environment.apiUrl}${endPoint}`, options);
  }


  /**
   * Get parameters for http query options
   *
   * @param parameters a list of query parameters
   */
  private getParams(parameters: any): HttpParams {
    let params = new HttpParams();

    if (parameters) {
      for (const key in parameters) {
        if (parameters[key] !== undefined) {
          params = params.set(key, parameters[key]);
        }
      }
    }

    return params;
  }

}
